export const gdpr = {
  routes: [
    {
      path: "/process",
      component: () => import("../organization-process-view"),
    },
  ],
};

export const workspace = {
  routes: [
    {
      path: "/workspace/library/process-category",
      component: () => import("../workspace-library-process-category-view"),
    },
    {
      path: "/workspace/library/process",
      component: () => import("../workspace-library-process-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/process-category",
      component: () => import("../management-library-process-category-view"),
    },
    {
      path: "/management/process",
      component: () => import("../management-library-process-view"),
    },
  ],
};
